export default function countOccurrences(inputArray) {
  return inputArray.reduce((acc, s) => {
    acc.hasOwnProperty(s) ? (acc[s] = acc[s] + 1) : (acc[s] = 1);
    return acc;
  }, {});
}
